import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cce8df9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card pb-0" }
const _hoisted_4 = { class: "p-fluid grid cuadros-visor-barra" }
const _hoisted_5 = {
  key: 0,
  class: "field col-12 sm:col-12 md:col-4 lg:col-4 xl:col-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "finicio" }, "Fecha de inicio", -1))
const _hoisted_7 = {
  key: 0,
  id: "val_finicio",
  class: "p-error"
}
const _hoisted_8 = {
  key: 1,
  class: "field col-12 sm:col-12 md:col-4 lg:col-4 xl:col-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ftermino" }, "Fecha de término", -1))
const _hoisted_10 = {
  key: 0,
  id: "val_ftermino",
  class: "p-error"
}
const _hoisted_11 = {
  key: 2,
  class: "col-12 sm:col-12 md:col-4 lg:col-4 xl:col-3"
}
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ftermino" }, "Año", -1))
const _hoisted_14 = {
  key: 3,
  class: "col-12 sm:col-12 md:col-4 lg:col-4 xl:col-3"
}
const _hoisted_15 = { class: "field col-12 sm:col-12 md:col-4 lg:col-4 xl:col-6 flex justify-content-end align-items-end" }
const _hoisted_16 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-wrench text-xl" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "col-12 field" }
const _hoisted_21 = { class: "grid cuadros-visor-info" }
const _hoisted_22 = { class: "col-12 md:col-5 lg:col-4 xl:col-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Datos disponibles desde: ", -1))
const _hoisted_24 = { class: "col-12 md:col-3 lg:col-4 xl:col-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Hasta: ", -1))
const _hoisted_26 = { class: "col-12 md:col-4 lg:col-4 xl:col-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Periodicidad: ", -1))
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "card" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Metadatos", -1))
const _hoisted_31 = { class: "grid metadato" }
const _hoisted_32 = { class: "key col-2 p-0" }
const _hoisted_33 = { class: "val col-10 p-0" }
const _hoisted_34 = { class: "grid metadato pt-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key col-2 p-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Series referenciadas")
], -1))
const _hoisted_36 = { class: "val col-10 p-0" }
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "mb-0" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Más opciones")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  onclick: "return false",
  class: "no-underline text-blue-400"
}, " contacto.sie@energia.gob.mx ", -1))
const _hoisted_44 = { class: "card pb-1" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Totalizaciones", -1))
const _hoisted_46 = { class: "grid" }
const _hoisted_47 = { class: "field col-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Periodicidad origen", -1))
const _hoisted_49 = { class: "p-inputtext flex" }
const _hoisted_50 = { class: "field col-4" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Periodicidad nueva", -1))
const _hoisted_52 = { class: "grid" }
const _hoisted_53 = { class: "field col-4" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Unidad origen", -1))
const _hoisted_55 = { class: "field col-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Unidad destino", -1))
const _hoisted_57 = { class: "field col-4 flex align-items-end" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Agregar", -1))
const _hoisted_60 = { class: "flex justify-content-end" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, [
    /*#__PURE__*/_createTextVNode("Prefijo "),
    /*#__PURE__*/_createElementVNode("strong", null, "M")
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "text-xs mt-0" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Para MW, MVA, MVAR, MJ, MWh: que son unidades de energía y potencia, el prefijo "),
      /*#__PURE__*/_createElementVNode("strong", null, "M"),
      /*#__PURE__*/_createTextVNode(" significa "),
      /*#__PURE__*/_createElementVNode("strong", null, "Mega"),
      /*#__PURE__*/_createTextVNode(" (1,000,000)")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "Para las demás unidades:"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("El prefijo "),
        /*#__PURE__*/_createElementVNode("strong", null, "M"),
        /*#__PURE__*/_createTextVNode(" significa "),
        /*#__PURE__*/_createElementVNode("strong", null, "Miles"),
        /*#__PURE__*/_createTextVNode(" (1,000)")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("El prefijo "),
        /*#__PURE__*/_createElementVNode("strong", null, "MM"),
        /*#__PURE__*/_createTextVNode(" significa "),
        /*#__PURE__*/_createElementVNode("strong", null, "Millones"),
        /*#__PURE__*/_createTextVNode(" (1,000,000)")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("El prefijo "),
        /*#__PURE__*/_createElementVNode("strong", null, "MMM"),
        /*#__PURE__*/_createTextVNode(" significa "),
        /*#__PURE__*/_createElementVNode("strong", null, "Miles de Millones"),
        /*#__PURE__*/_createTextVNode(" (1,000,000,000)")
      ])
    ])
  ])
], -1))
const _hoisted_63 = {
  key: 1,
  class: "pl-2"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Restablecer", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Aceptar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_fa = _resolveComponent("fa")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.error$.mostrar)
      ? (_openBlock(), _createBlock(_component_Message, {
          severity: "error",
          key: _ctx.error$.msg
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error$.msg), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.tipoControlFecha == 'Rango')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Calendar, {
                    id: "finicio",
                    "show-icon": true,
                    dateFormat: "dd/mm/yy",
                    modelValue: _ctx.fechas.fechaIni,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fechas.fechaIni) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.validarFecha()))
                    ]
                  }, null, 8, ["modelValue"]),
                  ((_ctx.v$.fechaIni.$error))
                    ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.fechaIni.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tipoControlFecha == 'Rango')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_Calendar, {
                    id: "ftermino",
                    "show-icon": true,
                    dateFormat: "dd/mm/yy",
                    modelValue: _ctx.fechas.fechaFin,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fechas.fechaFin) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.validarFecha()))
                    ]
                  }, null, 8, ["modelValue"]),
                  ((_ctx.v$.fechaFin.$error))
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.fechaFin.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tipoControlFecha == 'Anual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_Calendar, {
                      id: "fanio",
                      "show-icon": true,
                      view: "year",
                      dateFormat: "yy",
                      modelValue: _ctx.fechas.fechaIni,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fechas.fechaIni) = $event)),
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.validarFecha()))
                      ]
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tipoControlFecha == 'Anual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.mostrarBotonMasOpciones && _ctx.conversion_medida)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      class: "p-button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (this.mostrarOpciones = true))
                    }, _hoisted_18)), [
                      [
                        _directive_tooltip,
                        'Más opciones',
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createElementVNode("div", null, [
                _createVNode(_component_SplitButton, {
                  class: "bg-primary border-round",
                  model: _ctx.exportItems
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      class: "p-button-icon-only p-button-sm",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportarCuadro('.xlsx')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa, {
                          icon: "file-excel",
                          class: "xls-ico"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.titulo_cuadro), 1),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createTextVNode(_toDisplayString(this.formatoFecha(_ctx.fecha_cobertura_inicio)), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createTextVNode(_toDisplayString(this.formatoFecha(_ctx.fecha_cobertura_termino)), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createTextVNode(_toDisplayString(_ctx.periodicidad), 1)
              ])
            ])
          ]),
          (_ctx.cuadroLoad)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                shape: "rectangle",
                height: "3rem"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "styled-table",
                innerHTML: _ctx.cuadroHTML
              }, null, 8, _hoisted_28))
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cuadroMetadatos, (value, key, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "grid col-12",
                key: index
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("b", null, _toDisplayString(value.descripcion), 1)
                ]),
                _createElementVNode("div", _hoisted_33, _toDisplayString(value.valor), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("table", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cuadroMetadatosUso, (value, key, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("p", _hoisted_38, _toDisplayString(value.id_serie), 1)
                    ]),
                    _hoisted_39,
                    _createElementVNode("td", _hoisted_40, [
                      _createElementVNode("p", _hoisted_41, _toDisplayString(value.nombre_corto) + "; " + _toDisplayString(value.clasificacion), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      class: "cuadros-modal-opciones",
      visible: _ctx.mostrarOpciones,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mostrarOpciones) = $event)),
      modal: true,
      closable: true
    }, {
      header: _withCtx(() => [
        _hoisted_42
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "btn_nc_volver",
          class: "p-button p-button-secondary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.limpiarModalOpciones()))
        }, {
          default: _withCtx(() => [
            _hoisted_64
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          id: "btn_nc_guardar",
          class: "p-button p-button-primary",
          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.obtenerVistaParametros()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _hoisted_65
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          severity: "info",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Este aplicativo está en procesos de pruebas, en caso de identificar una falla, favor de enviar un correo a "),
            _hoisted_43
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.periodicidad), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createVNode(_component_Dropdown, {
                class: "flex",
                modelValue: _ctx.masOpciones.periodicidadNueva,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.masOpciones.periodicidadNueva) = $event)),
                options: _ctx.catCuadroPeriodicidad,
                optionLabel: "periodicidad_destino",
                optionValue: "id_periodicidad_destino",
                placeholder: "Seleccionar"
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]),
        (_ctx.catCuadroUnidadMedida.length>0)
          ? (_openBlock(), _createBlock(_component_Fieldset, {
              key: 0,
              legend: "Conversión de unidades",
              toggleable: true,
              collapsed: !(this.parametrosCuadro.Conversion.length > 0),
              class: "pb-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createVNode(_component_Dropdown, {
                      class: "flex",
                      modelValue: _ctx.masOpciones.unidadOrigen,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.masOpciones.unidadOrigen) = $event)),
                      options: _ctx.catCuadroUnidadMedida,
                      optionValue: "id_unidad_medida",
                      optionLabel: "unidad_medida",
                      placeholder: "Seleccionar",
                      onChange: _ctx.getCuadroUnidadMedidaDestino
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode(_component_Dropdown, {
                      class: "flex",
                      modelValue: _ctx.masOpciones.unidadDestino,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.masOpciones.unidadDestino) = $event)),
                      options: _ctx.catCuadroUnidadMedidaDestino,
                      optionLabel: "unidad_medida_destino",
                      optionValue: "id_unidad_medida_destino",
                      placeholder: "Seleccionar"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_Button, {
                        id: "btn_agregar",
                        class: "p-button p-button-primary",
                        onClick: _withModifiers(_ctx.agregarConversion, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_59
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_DataTable, {
                    value: _ctx.masOpciones.tconversiones
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "conversion",
                        header: "Conversión"
                      }),
                      _createVNode(_component_Column, null, {
                        body: _withCtx((item) => [
                          _createElementVNode("div", _hoisted_60, [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              class: "p-button p-component p-button-icon-only p-button-text p-button-plain p-button-rounded p-button-danger",
                              type: "button",
                              id: "btn_eliminar",
                              onClick: ($event: any) => (_ctx.eliminaConversion(item.data))
                            }, [
                              _createVNode(_component_fa, {
                                icon: "xmark",
                                class: "archivo_eliminar"
                              })
                            ], 8, _hoisted_61)), [
                              [
                                _directive_tooltip,
                                'Eliminar',
                                void 0,
                                { top: true }
                              ]
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _hoisted_62
              ]),
              _: 1
            }, 8, ["collapsed"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_63, [
              _createVNode(_component_fa, { icon: "circle-info" }),
              _createTextVNode(" No hay unidades de medida disponibles para conversión. ")
            ]))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}